<div class="customize-modal" *transloco="let t; prefix: 'maintenanceCosting.modals.customizeColumn'">
  <div class="customize-modal__header">
    <h3 class="customize-modal__title">{{ t('title') }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <p class="customize-modal__subtitle">{{ t('subtitle', { count: maxSelections }) }}</p>

  <div class="customize-modal__list">
    @for (column of columns; track column.value) {
      <div class="column-item" (click)="toggleColumn(column)" [class.disabled]="!column.selected && !canSelectMore">
        <div class="column-item__checkbox">
          @if (column.selected) {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737"/>
              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737"/>
              <path d="M2.95312 8.85677L6.28646 11.9818L12.9531 3.64844" stroke="white" stroke-width="2" stroke-linejoin="round"/>
            </svg>
          } @else if (!canSelectMore) {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#E6E6E6"/>
              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#E6E6E6"/>
            </svg>
          } @else {
            <div class="checkbox-unchecked"></div>
          }
        </div>
        <span class="column-item__label">{{ column.labelKey | transloco }}</span>
      </div>
    }
  </div>

  <div class="customize-modal__actions">
    <button type="button" class="btn-cancel" (click)="cancel()">
      {{ 'common.cancel' | transloco }}
    </button>

    <button type="button" class="btn-save" [disabled]="isSaveDisabled" (click)="save()">
      {{ t('save') }}
    </button>
  </div>
</div>